import { connect } from 'react-redux';
import AdminSettingForm from './AdminSettingForm';

import * as AdminLoginActions from './AdminSettingActionCreator';
import * as localeActions from './AdminSettingLocalActionCreator';

const mapStateToProps = state => {
  const auth =
    state.get('auth') && state.get('auth').toJS && state.get('auth').toJS();
  const kiosk =
    state.get('kiosk') && state.get('kiosk').toJS && state.get('kiosk').toJS();
  return {
    ...auth,
    ...kiosk
  };
};

const mapDispatchToProps = {
  ...AdminLoginActions,
  ...localeActions
};

const AdminSettingFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminSettingForm);

export default AdminSettingFormContainer;
